export default __webpack_public_path__ + "static/media/fastfood_1.b5c9cd60.jpg";